export const COUNT_OF_SERVICE_TYPE = 5;

export const WORK_REQUEST_TYPE = {
  OPERATIONAL_AWARENESS: "OPERATIONAL_AWARENESS",
  NEW: "NEW",
  IN_PROGRESS: "IN_PROGRESS",
  REQUIRES_APPROVAL: "REQUIRES_APPROVAL",
  INSPECTIONS: "INSPECTIONS",
  PREVENTATIVE_MAINTENANCE: "PREVENTATIVE_MAINTENANCE",
  ALL: "ALL",
  OPEN: "OPEN",
  COMPLETED: "COMPLETED",
  PLANNED: "PLANNED",
  APPROVAL_REQUIRED: "APPROVAL_REQUIRED",
};
